import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Virtualization lets you run multiple isolated systems on shared hardware, using resources far more efficiently. We design and implement virtualization that reduces cost and simplifies management.",
    "Beyond savings, virtualization improves resilience — snapshots, quick recovery and easy scaling make your infrastructure more robust.",
];

const FEATURES = [
    { title: "Consolidate hardware", text: "Run more workloads on less physical kit, cutting cost and footprint." },
    { title: "Better resource use", text: "Allocate compute and storage dynamically where it's needed." },
    { title: "Improved resilience", text: "Snapshots and rapid recovery reduce the impact of failures." },
    { title: "Easy scaling", text: "Spin up and resize environments quickly as demand changes." },
];

const CHECKS = [
    "Server virtualization",
    "Desktop virtualization",
    "Resource optimisation",
    "Backup & snapshot strategy",
    "Ongoing management",
];

export default function VirtualizationSolutions() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Virtualization Solutions" eyebrowAs="span">
                    Do more with less hardware — virtualization that consolidates infrastructure, cuts cost and improves resilience.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
